import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebookColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 6,
			cy: 6,
			r: 5.25,
			fill: "url(#paint0_linear_444_1509)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.95514 7.60558L8.18835 6.12379H6.72946V5.16262C6.72946 4.75714 6.93287 4.36165 7.58631 4.36165H8.25V3.10012C8.25 3.10012 7.64794 3 7.0726 3C5.87056 3 5.08562 3.70985 5.08562 4.99442V6.12379H3.75V7.60558H5.08562V11.1879C5.35377 11.229 5.62809 11.25 5.90754 11.25C6.18699 11.25 6.46131 11.229 6.72946 11.1879V7.60558H7.95514Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_444_1509",
			x1: 6,
			y1: .75,
			x2: 6,
			y2: 11.2189,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#18ACFE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0163E0"
			})]
		}) })
	]
});
export default SvgFacebookColor;
